var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Children } from 'react';
import { any, bool } from 'prop-types';
import last from 'lodash/last';
import WixComponent from '../../BaseComponents/WixComponent';
import styles from './InputAreaWithLabelComposite.scss';
import FieldLabelAttributes from '../../FieldLabelAttributes/FieldLabelAttributes';

var InputAreaWithLabelComposite = function (_WixComponent) {
  _inherits(InputAreaWithLabelComposite, _WixComponent);

  function InputAreaWithLabelComposite() {
    _classCallCheck(this, InputAreaWithLabelComposite);

    return _possibleConstructorReturn(this, (InputAreaWithLabelComposite.__proto__ || Object.getPrototypeOf(InputAreaWithLabelComposite)).apply(this, arguments));
  }

  _createClass(InputAreaWithLabelComposite, [{
    key: 'render',
    value: function render() {
      var children = Children.toArray(this.props.children);
      return React.createElement(
        'div',
        null,
        children.length === 2 ? React.createElement(
          'div',
          { className: styles.label },
          children[0],
          this.props.required || this.props.info ? React.createElement(FieldLabelAttributes, { required: this.props.required, info: this.props.info }) : null
        ) : null,
        last(children)
      );
    }
  }]);

  return InputAreaWithLabelComposite;
}(WixComponent);

InputAreaWithLabelComposite.propTypes = {
  children: any,
  required: bool
};

InputAreaWithLabelComposite.displayName = 'InputAreaWithLabelComposite';

export default InputAreaWithLabelComposite;
//# sourceMappingURL=InputAreaWithLabelComposite.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite.js